const HeroBannerSuspense = () => {
  return (
    <div className='relative flex content-center items-center justify-center h-fit lg:h-screen bg-place-holder pt-20 pb-4 box-border'>
      <div className='absolute top-0 h-full w-full bg-cover bg-no-repeat bg-hero-banner' />
    </div>
  );
};

export default HeroBannerSuspense;
